<!--
 * @Author: mzw
 * @Date: 2021-09-18 14:35:27
 * @LastEditors: mzw
 * @LastEditTime: 2021-11-16 10:12:51
 * @Description: 发票列表组件
-->
<template>
    <div>
        <div class="bill-box" v-if="dataLists.length>0">
            <ul>
                <li v-for="(item, index) in dataLists"
                    :key="index" :class="[item.invoiceId == checkedInvoiceId ? 'checked-li':'' ]"
                    @click="billChangeHandle(item)"
                    @mouseenter="enters(item.invoiceId)"
                    @mouseleave="leaver">
                    <div class="bill-info">
                    <p><label>发票抬头：</label>{{item.companyName}}</p>
                    <p><label>税务登记证号：</label>{{item.taxpayerIdentity}}<span v-if="item.defaultFlag === '1'" class="flag">默认</span></p>
                    <template v-if="activeName=='first'">
                        <p><label>开户银行名称：</label>{{item.openingBank}}</p>
                        <p><label>基本开户账号：</label>{{item.bankAccountNo}}</p>
                        <p><label>注册场所地址：</label>{{item.companyAddress}}</p>
                        <p><label>注册固定电话：</label>{{item.companyPhone}}</p>
                    </template>
                    </div>
                    <div class="ad-btnBox" v-show="hoverId==item.invoiceId">
                        <span @click.stop="invoiceEditHandle(item)">编辑发票</span>
                        <span @click.stop="invoiceDeleteHandle(item)">删除发票</span>
                    </div>
                </li>
            </ul>
            <span @click="toggleInvoice(moreInvoiceVisible)">
                <template v-if="moreInvoiceVisible">
                    收起发票<i class="el-icon-arrow-up"></i>
                </template>
                <template v-if="!moreInvoiceVisible">
                    更多发票<i class="el-icon-arrow-down"></i>
                </template>
            </span>
        </div>
        <div class="bill-box" v-else>
            <div class="no-data">没有任何发票</div>
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      hoverId: '', // 鼠标移入id
      dataLists: []
    }
  },
  props: {
    payInvoiceList: {
      type: Array,
      default: () => {
        return []
      }
    },
    checkedInvoiceId: {
      type: String,
      default: ''
    },
    activeName: {
      type: String,
      default: 'first'
    },
    moreInvoiceVisible: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    payInvoiceList: {
      handler (newVal) { // 只能写handler才能生效
        this.dataLists = newVal // 设置初始dataLists值
      },
      immediate: true
    },
    moreInvoiceVisible (val) {
      let oldLists = this.payInvoiceList
      let checkedId = this.checkedInvoiceId
      if (!val) { // 收起地址 仅展示一条：有选中则展示选中条，无则展示第一条
        if (!checkedId) {
          this.dataLists = [].concat(oldLists[0])
        } else {
          let dataLists = oldLists.filter(item => {
            return item.invoiceId === checkedId
          })
          if (dataLists && dataLists.length > 0) {
            this.dataLists = dataLists
          } else {
            this.dataLists = [].concat(oldLists[0])
          }
        }
      } else { // 展开地址 展示所有地址列表
        this.dataLists = oldLists
      }
    }
  },
  methods: {
    billChangeHandle (item) {
      this.$emit('billChangeHandle', item)
    },
    invoiceEditHandle (item) {
      this.$emit('invoiceEditHandle', item)
    },
    invoiceDeleteHandle (item) {
      this.$emit('invoiceDeleteHandle', item)
    },
    toggleInvoice (flag) {
      this.$emit('toggleInvoice', flag)
    },
    enters (id) {
      this.hoverId = id
    },
    leaver () {
      this.hoverId = ''
    }
  }
}
</script>
<style lang='scss' scoped>
    .bill-box {
        width: 100%;
        height: auto;
        background: #F9F9F9;
        box-sizing: border-box;
        border: 1px solid #ddd;
        padding: 24px;
        &>ul {
            width: 100%;
            max-height: 250px;
            overflow-y: auto;
            li {
                padding-right: 8px;
                box-sizing: border-box;
                overflow: hidden;
                margin-bottom: 15px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                &:hover {
                    background-color: #F2F2F2;
                }
                .ad-btnBox {
                    font-size: 14px;
                    height: 36px;
                    line-height: 36px;
                    &>span {
                        margin-left: 24px;
                        color: #3D88D4;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }

                &.checked-li {
                    border: 1px solid #3D88D4;
                }
                .bill-info {
                    width: 899px;
                    padding: 0 20px;
                    box-sizing: border-box;
                    line-height: 36px;
                    &>p {
                        width: 50%;
                        float: left;
                        margin: 0;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        label {
                            width: 98px;
                            color: #797979;
                            text-align: right;
                            display: inline-block;
                        }
                        .flag {
                            display: inline-block;
                            padding: 0 3px;
                            height: 17px;
                            line-height: 17px;
                            background: #3D88D4;
                            color: #fff;
                            font-size: 12px;
                            margin-left: 28px;
                        }
                    }
                }
            }
        }
        &>span {
            color: #797979;
            cursor: pointer;
        }
        .no-data{
            color: #797979;
        }
    }
</style>
